(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('EntityActionApprovalPolicyDialogController', EntityActionApprovalPolicyDialogController);

    EntityActionApprovalPolicyDialogController.$inject = ['Workflow', '$scope', '$state', 'entity', '$rootScope', '$uibModalInstance', 'workflowSharedService', 'EntityActionApprovalPolicy', 'GlobalValues', 'CSPLPagination', 'ScreenLog','entityConstants'];

    function EntityActionApprovalPolicyDialogController(Workflow, $scope, $state, entity,  $rootScope,  $uibModalInstance, workflowSharedService, EntityActionApprovalPolicy, GlobalValues, CSPLPagination, ScreenLog,entityConstants) {
        var vm = this;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.ENTITY_STATE_APPROVAL_PROCESS;
        vm.screenLog = ScreenLog;
        vm.save = save;
        vm.entityActionApprovalPolicyDTO = {};
        vm.selected = {entityActions: []};
        
        vm.clear = clear;
        vm.approveEntityActionApprovalPolicy = approveEntityActionApprovalPolicy;
        vm.rejectEntityActionApprovalPolicy = rejectEntityActionApprovalPolicy;
        vm.discardEntityActionApprovalPolicy = discardEntityActionApprovalPolicy;
        vm.resubmitEntityActionApprovalPolicy = resubmitEntityActionApprovalPolicy;
    	$scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.clicked=false;
        vm.selectAll=false;
    	vm.checkOrUncheckHeaderAction = checkOrUncheckHeaderAction;
    	vm.checkOrUncheckAction = checkOrUncheckAction;
        
        if(workflowSharedService.viewFrom == 'approvalPolicy'){
	        vm.entityActionApprovalPolicyDTO = entity;
			//ScreenLog.screenLog({'entityName': 'EntityStateApprovalProcess', 'entityRecordId': vm.entityActionApprovalPolicyDTO.id, 'action': 'MAP'});
	        vm.ShowApprovalPolicyLink = false;
	        showButtonsManipulateScreen();
        }
        else if(workflowSharedService.viewFrom == 'entityActionApprovalPolicytodolist_checker') {
        	vm.ShowApprovalPolicyLink = true;
        	vm.entityActionApprovalPolicyDTO =  angular.fromJson($rootScope.payload); 
        	showButtonsViewCheckerScreen();
        }
        else if(workflowSharedService.viewFrom == 'entityActionApprovalPolicytodolist_maker') {
        	vm.ShowApprovalPolicyLink = false;
        	vm.entityActionApprovalPolicyDTO =  angular.fromJson($rootScope.payload); 
        	console.log("maker screen");
        	showButtonsViewMakerScreen();
        }
        
        else if(workflowSharedService.viewFrom == 'entityActionApprovalPolicy_resubmit') {
        	console.log("resubmit screen");
        	vm.ShowApprovalPolicyLink = false;
        	vm.entityActionApprovalPolicyDTO = angular.fromJson($rootScope.payload); 
			vm.screenLog.screenLog(vm.screenName, vm.entityActionApprovalPolicyDTO.id, entityConstants.ENTITY_ACTION_TYPE.RESUBMIT);
        	showButtonsResubmitScreen();
        }
        else if(workflowSharedService.viewFrom == 'entityActionApprovalPolicy_auditLog') {
        	vm.ShowApprovalPolicyLink = false;
        	vm.entityActionApprovalPolicyDTO =  angular.fromJson($rootScope.payload); 
        	vm.btnClose=true;
        	vm.ViewDisable=true;
        }

        EntityActionApprovalPolicy.getEntityActions({orgId:GlobalValues.getOrgId(), id:vm.entityActionApprovalPolicyDTO.approvalPolicyId},function(result) {            
        	 vm.entityActionApprovalPolicies = result;
						    		//setupPagination(result);
						            vm.selected.entityActions = angular.copy(vm.entityActionApprovalPolicyDTO.entityActions);
						            if( vm.entityActionApprovalPolicies.length == vm.selected.entityActions.length){
								    	 vm.selectAll = true;
								    	 document.getElementById("selectAll").checked = true;
								     }
						            
						    });
        
        function showButtonsManipulateScreen(){
        	vm.ViewDisable = false;
            vm.btnClose = false;
            vm.btnApproveReject = false;
            $scope.showDiscardButton = false;
            $scope.showSaveButton = true;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = false;
        }
        function showButtonsViewCheckerScreen(){
        	$scope.showButton=true;
        	vm.ViewDisable = true;
        	$scope.showDiscardButton = false;
        	vm.btnClose = true;
        	$scope.showDiscardButton = false;
        	vm.btnApproveReject = true;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
        function showButtonsResubmitScreen(){
        	vm.ViewDisable = false;
        	vm.btnClose = false;
        	$scope.showButton=true;
        	vm.btnApproveReject = false;
        	$scope.showDiscardButton = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = true;
            $scope.showResubmitButton = true;
        }
        function showButtonsViewMakerScreen(){
        	vm.ViewDisable = true;
        	$scope.showButton=false;
        	$scope.showDiscardButton = true;
        	vm.btnClose = true;
        	vm.btnApproveReject = false;
        	$scope.showSaveButton = false;
            $scope.showCancelButton = false;
            $scope.showResubmitButton = false;
        }
		function clear () {
            $uibModalInstance.dismiss('cancel');
        }
		
		function save () {
			
			vm.entityActionApprovalPolicyDTO.entityActions = vm.selected.entityActions;
			EntityActionApprovalPolicy.map({"orgId":GlobalValues.getOrgId()}, vm.entityActionApprovalPolicyDTO, onSaveSuccess, onSaveError);
        }
     
        function onSaveSuccess (result) {
            $uibModalInstance.close(result);  
        }

        function onSaveError () {
        	vm.clicked=false;
        }
        function approveEntityActionApprovalPolicy() { 
        	EntityActionApprovalPolicy.approve({"taskId" : $rootScope.taskID},onApproveSuccess,onApproveError);         	
        	$uibModalInstance.dismiss('cancel');     	
        }
        
        function onApproveSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onApproveError(error) {
        	vm.clicked=false;
        }
       
        function rejectEntityActionApprovalPolicy() { Workflow.rejectTask($rootScope.taskID);}

        function discardEntityActionApprovalPolicy() {
        	EntityActionApprovalPolicy.discard({"taskId" : $rootScope.taskID},onDiscardSuccess,onDiscardError);         	
        	$uibModalInstance.dismiss('cancel');	
        }
        
        function onDiscardSuccess(result) {
        	$rootScope.removeRow($rootScope.taskID);        	
        }        
        function onDiscardError(error) {

        }
        function resubmitEntityActionApprovalPolicy() {
        	vm.entityActionApprovalPolicyDTO.entityActions = vm.selected.entityActions;
        	EntityActionApprovalPolicy.resubmit({"taskId" : $rootScope.taskID}, vm.entityActionApprovalPolicyDTO, onResubmitSuccess, onResubmitError);
          	$uibModalInstance.dismiss('cancel');
          }
          
          function onResubmitSuccess(result) {
          	$rootScope.removeRow($rootScope.taskID);
          }        
          function onResubmitError(error) { 
        	  vm.clicked=false;
          }
          
          function checkOrUncheckHeaderAction(event){
            	
        	  changeHeaderActionSelection(event.target.checked);
                 
          }
         function changeHeaderActionSelection(value){
      	 	if(value){
          		angular.forEach(vm.entityActionApprovalPolicies, function(item, index){
          		
          			//item.entityActions = true;
          			vm.selected.entityActions.push(item.entityActions);
          			
          		});
      		}else{
      			angular.forEach(vm.entityActionApprovalPolicies, function(item, index){
      				//item.entityActions = false;
      				vm.selected.entityActions = [];
      			});
      		}
          
          }
          function checkOrUncheckAction(){
          	          	
          	if(vm.selected.entityActions.length == vm.entityActionApprovalPolicies.length ){
          		vm.selectAll= true;
          		document.getElementById("selectAll").checked = true;
          	}else{
          		vm.selectAll= false;
          		document.getElementById("selectAll").checked = false;
          	}
          }
         
          /*// change -- used cspl-pagination tag
          function setupPagination(result){
      		vm.CSPLPagination = CSPLPagination;
      	    vm.CSPLPagination.initialisePagination('entityActionApprovalPolicy', vm.entityActionApprovalPolicies);
      		vm.totalRecordLength = vm.CSPLPagination.getTotalRecordCount('entityActionApprovalPolicy');
      		vm.itemsPerPage = vm.CSPLPagination.getItemsPerPage('entityActionApprovalPolicy');
      		vm.pageCount = 1;
              $scope.$watch('vm.pageCount', function(){
              	vm.CSPLPagination.setPage('entityActionApprovalPolicy', vm.pageCount);
              	vm.pagedValues = vm.CSPLPagination.getPagedValues('entityActionApprovalPolicy');
              });
     }*/
    }
})();
